<template>
  <div v-if="pageGroupedElements.length">
    <div
      v-for="(page, index) in pageGroupedElements"
      :key="'page-' + index"
      class="position-relative dinA4"
    >
      <img :src="require('@/assets/insular-header-pt.png')" class="mb-0 page__header" />

      <div class="page__container">
        <div
          v-for="(combo, comboIndex) in page"
          :key="'combo-' + comboIndex"
        >
          <div
            v-if="combo[0] && combo[0].type === 'table'"
            class="d-flex justify-center"
            :class="{ 'mt-10': comboIndex > 0 }"
          >
            <PdfProductTable
              v-for="(id, i) in combo[0].ids"
              :key="'table-' + i"
              :type="combo[0].tableType"
              :tableData="productTableList[id]"
              :tableId="id"
              :image="(combo[0].images && combo[0].images[id]) || combo[0].imageUrl"
              :descKey="getProduct(id) ? getProduct(id).desc_key : ''"
            />
          </div>

          <div
            v-if="combo[1] && combo[1].type === 'text'"
            class="d-flex justify-center mt-5"
          >
            <div :class="combo[1].extraWide ? 'small-letter-section-extrawide' : 'small-letter-section'">
              <p
                v-if="combo[1].title"
                class="small-letter-font small-letter-font--bold mb-2"
              >
                {{ combo[1].title }}
              </p>
              <p
                v-if="combo[1].intro"
                class="small-letter-font small-letter-font--bold mb-0"
              >
                {{ combo[1].intro }}
              </p>
              <ul class="small-letter-font justify-text spaced-list">
                <li
                  v-for="(elementList, listIndex) in combo[1].list"
                  :key="'textList-' + listIndex"
                  v-html="elementList"
                />
              </ul>
              <p
                v-if="combo[1].outro"
                class="small-letter-font justify-text mt-6 mb-0"
                v-html="combo[1].outro"
              />
            </div>
          </div>
        </div>
        <div v-if="index === pageGroupedElements.length - 1" class="note-section mt-10">
          <p class="small-letter-font justify-text" v-html="$t('NOTE_INSULAR')"></p>
        </div>
      </div>
      
      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Footer'

export default {
  name: 'InsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        // {
        //   type: 'table',
        //   imageUrl: require('@/assets/cttcanarias-icon.png'),
        //   ids: ['CANEXPRESS', 'CANECOMMERCE'],
        //   tableType: 'cannary',
        // },
        {
          type: 'table',
          ids: ['IlhasPTEMadeira', 'IlhasPTEAcores'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          title: 'Características do serviço Ilhas PT (Aéreo):',
          relatedTableType: 'cannary',
          extraWide: true,
          list: [
            '• <b>Produto:</b> 24h (19h); <b>Fluxo:</b> PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
            '• <b>Produto:</b> 24hM (19M); <b>Fluxo:</b> PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167 kg/m³ (meio de transporte aéreo).',
            '• <b>Serviços Adicionais:</b> Cobrança, Proteção Extra, Back, DDA, SMS.'
          ]
        },
        {
          type: 'table',
          ids: ['IlhasPTM'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          title: 'Características do serviço Ilhas PT (Marítimo):',
          relatedTableType: 'cannary',
          extraWide: true,
          list: [
            '• <b>Produto:</b> 48h; <b>Fluxo:</b> PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 333 kg/m³ (meio de transporte marítimo).',
            '• <b>Serviços Adicionais:</b> Cobrança, Proteção Extra, Back, DDA, SMS.'
          ]
        },
        {
          type: 'table',
          ids: ['InterilhasPT'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          title: 'Características do serviço Interilhas PT (Mesma Ilha):',
          relatedTableType: 'cannary',
          extraWide: true,
          list: [
            ' • <b>Produto:</b> 24h (19h); <b>Fluxo:</b> PT Açores > PT Açores; PT Madeira > PT Madeira.',
            ' • <b>Produto:</b> 24hM (19M); <b>Fluxo:</b> PT Açores > PT Açores; PT Madeira > PT Madeira.',
            ' • <b>Peso máximo por objeto:</b> 30 kg.',
            ' • <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m³ (meio de transporte terrestre).',
            '<b>Características do serviço Interilhas PT (Mesmo Arquipélago):</b>',
            ' • <b>Produto:</b> 48h; <b>Fluxo:</b> PT Açores > PT Açores; PT Madeira > PT Madeira.',
            ' • <b>Peso máximo por objeto:</b> 30 kg.',
            ' • <b>Cubicagem:</b> Conversão volumétrica de 333 kg/m³ (meio de transporte marítimo).',
            '<b>Características do serviço Interilhas PT (Entre Arquipélagos):</b>',
            ' • <b>Produto:</b> 24h (19h); <b>Fluxo:</b> PT Açores > PT Madeira; PT Madeira > PT Açores.',
            ' • <b>Produto:</b> 24hM (19M); <b>Fluxo:</b> PT Açores > PT Madeira; PT Madeira > PT Açores.',
            ' • <b>Peso máximo por objeto:</b> 5 kg.',
            ' • <b>Cubicagem:</b> Conversão volumétrica de 167 kg/m³ (meio de transporte aéreo).',
            ' • <b>Medidas máximas por objeto:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            ' • <b>Medidas mínimas por objeto:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            ' • <b>Serviços Adicionais:</b> Cobrança, Proteção Extra, Back, DDA, SMS.'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          ids: ['BalearesAereo', ],
          tableType: 'balear',
        },
        {
          type: 'text',
          title: 'Características do serviço Ilhas Baleares (Aéreo):',
          relatedTableType: 'balear',
          extraWide: true,
          list: [
            '• <b>Produto:</b> 24h (19h); <b>Fluxo:</b> PT Continente > ES Baleares; ES Baleares > PT Continente.',
            '• <b>Produto:</b> 24hM (19M); <b>Fluxo:</b> PT Continente > ES Baleares; ES Baleares > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167 kg/m³ (meio de transporte aéreo).',
            '• <b>Serviços Adicionais:</b> Cobrança, Proteção Extra, Back, DDA, SMS.'
          ]
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          ids: ['BalearesMaritimo'],
          tableType: 'balear',
        },
        {
          type: 'text',
          title: 'Características do serviço Ilhas Baleares (Marítimo):',
          relatedTableType: 'balear',
          extraWide: true,
          list: [
            '• <b>Produto:</b> 48h; <b>Fluxo:</b> PT Continente > ES Baleares; ES Baleares > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 333 kg/m³ (meio de transporte marítimo).',
            '• <b>Serviços Adicionais:</b> Cobrança, Seguro Extra, Back, DDA, SMS.'
          ]
        },
        {
          type: 'table',
          ids: ['CanariasAereo'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          title: 'Características do serviço Ilhas Canárias (Aéreo):',
          relatedTableType: 'cannary',
          extraWide: true,
          list: [
            '• <b>Produto:</b> 24h (19h); <b>Fluxo:</b> PT Continente > ES Canárias; ES Canárias > PT Continente.',
            '• <b>Produto:</b> 24hM (19M); <b>Fluxo:</b> PT Continente > ES Canárias; ES Canárias > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Despacho Único Aduaneiro (DUA):</b> Disponível para destinos com sistema Alfandegário; Aos valores indicados na tabela acresce a taxa no valor de 22,38€.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167 kg/m³ (meio de transporte aéreo).',
            '• <b>Serviços Adicionais:</b> Cobrança, Seguro Extra, Back, DDA, SMS.'
          ]
        },        
        {
          type: 'table',
          imageUrl: require('@/assets/cttotherdest-icon.png'),
          ids: ['OtrosDestinos'],
          tableType: 'otherDestinations',
        },
        {
        type: 'text',
        title: 'Características do serviço Ceuta, Melilla, Gibraltar e Andorra:',
        relatedTableType: 'otherDestinations',
        extraWide: true,
        list: [
          '• <b>Produto:</b> 24h (19H); <b>Fluxo:</b> PT Continente > Ceuta, Melilla, Gibraltar, Andorra.',
          '• <b>Produto:</b> 24hM (19M); <b>Fluxo:</b> PT Continente > Ceuta, Melilla, Gibraltar, Andorra.',
          '• <b>Peso máximo por volume:</b> 30 kg.',
          '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
          '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
          '• <b>Despacho Único Aduaneiro (DUA):</b> Disponível para destinos com sistema Alfandegário; Aos valores indicados na tabela acresce a taxa no valor de 22,38€.',
          '• <b>Cubicagem:</b> Conversão Volumétrica 167 kg/m³ (meio de transporte aéreo).',
          '• <b>Serviços Adicionais:</b> Cobrança, Proteção Extra, Back, DDA, SMS.'
        ]
      },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },

    combinedElements() {
      const combos = []
      const { elements } = this
      let i = 0

      while (i < elements.length) {
        const current = elements[i]

        if (current.type === 'table') {
          const selectedIds = current.ids.filter(id => this.isProductSelected(id))
          if (!selectedIds.length) {
            i++
            continue
          }

          const tableCopy = { ...current, ids: selectedIds }

          const nextEl = elements[i + 1]
          if (
            nextEl &&
            nextEl.type === 'text' &&
            nextEl.relatedTableType === tableCopy.tableType
          ) {
            combos.push([tableCopy, nextEl])
            i += 2
          } else {
            combos.push([tableCopy])
            i++
          }
        }
        else {
          i++
        }
      }
      return combos
    },


    pageGroupedElements() {
      const combos = this.combinedElements
      if (!combos.length) return []
      return combos.map(combo => [combo])
    },
  },
  methods: {
    isProductSelected(tableId) {
      const product = this[GET_PRODUCT](tableId)
      return product && product.isPreSelected === true
    },
    getProduct(productId) {
      return this[GET_PRODUCT](productId)
    },
  },
  created() {
    this.$emit('updateTotalPages', { InsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularTables')
  },
}
</script>
